<app-logo-header [buyerPages]="true"></app-logo-header>
<div class="section">
  <div *ngIf="isProduct && available">
    <app-buyer-view [incomingProduct]="productObject"></app-buyer-view>
  </div>

  <div *ngIf="isShop && available">
    <app-seller-view [products]="productsList" [businessData]="businessObject"></app-seller-view>
  </div>

  <app-error
    *ngIf="!available"
    [title]="'Ooops!'"
    [message]="errorMessage"
    [redirectURL]="'/products/browse'">
  </app-error>
</div>


